
const INITIAL_STATE: PrintState = {
  headerPageCssClass: '',
  printableImageClass: '',
  breadcrumbCssClass: '',
  breadcrumbTitleCssClass: '',
  tablesCssClass: '',
  fullLeftPanelCssClass: '',
  leftPanelCssClass: '',
  estimateImageCssClass: '',
  printAvailable: true
};

const SET_HEADER_FULL_CONTENT: PrintState = {
  headerPageCssClass: '',
  printableImageClass: 'no-print',
  breadcrumbCssClass: '',
  breadcrumbTitleCssClass: 'no-print',
  tablesCssClass: '',
  fullLeftPanelCssClass: '',
  leftPanelCssClass: '',
  estimateImageCssClass: 'no-print',
  printAvailable: true
};

const SET_HEADER_NOT_FULL_CONTENT: PrintState = {
  headerPageCssClass: '',
  printableImageClass: '',
  breadcrumbCssClass: '',
  breadcrumbTitleCssClass: 'no-print',
  tablesCssClass: 'no-print',
  fullLeftPanelCssClass: '',
  leftPanelCssClass: 'no-print',
  estimateImageCssClass: '',
  printAvailable: true
};

const NO_HEADER_ONLY_CONTENT: PrintState = {
  headerPageCssClass: 'no-print !important',
  printableImageClass: 'img-size-full',
  breadcrumbCssClass: 'no-print !important',
  breadcrumbTitleCssClass: 'no-print',
  tablesCssClass: 'no-print',
  fullLeftPanelCssClass: 'no-print',
  leftPanelCssClass: 'no-print',
  estimateImageCssClass: 'no-print',
  printAvailable: true
};

const PRINT_NOT_AVAILABLE: PrintState = {
  headerPageCssClass: 'no-print !important',
  printableImageClass: 'no-print',
  breadcrumbCssClass: '',
  breadcrumbTitleCssClass: '',
  tablesCssClass: 'no-print',
  fullLeftPanelCssClass: 'no-print',
  leftPanelCssClass: 'no-print',
  estimateImageCssClass: 'no-print',
  printAvailable: false
};

const PRINT_STATE = 'PRINT_STATE';

export const PrintStateActions = {
  INIT: `${PRINT_STATE}.PRINT_STATE_INIT`,
  SET_HEADER_FULL_CONTENT: `${PRINT_STATE}.SET_HEADER_FULL_CONTENT`,
  SET_HEADER_NOT_FULL_CONTENT: `${PRINT_STATE}.SET_HEADER_NOT_FULL_CONTENT`,
  SET_NO_HEADER_ONLY_CONTENT: `${PRINT_STATE}.SET_NO_HEADER_ONLY_CONTENT`,
  SET_PRINT_NOT_AVAILABLE: `${PRINT_STATE}.SET_PRINT_NOT_AVAILABLE`,
};

export function printReducer(state: PrintState = INITIAL_STATE, action: any) {
  switch (action.type) {
    case PrintStateActions.INIT:
      state = INITIAL_STATE;
      return state;
    case PrintStateActions.SET_HEADER_FULL_CONTENT:
      state = SET_HEADER_FULL_CONTENT;
      return state;
    case PrintStateActions.SET_HEADER_NOT_FULL_CONTENT:
      state = SET_HEADER_NOT_FULL_CONTENT;
      return state;
    case PrintStateActions.SET_NO_HEADER_ONLY_CONTENT:
      state = NO_HEADER_ONLY_CONTENT;
      return state;
    case PrintStateActions.SET_PRINT_NOT_AVAILABLE:
      state = PRINT_NOT_AVAILABLE;
      return state;
    default:
      return state;
  }
}


export interface PrintState {
  headerPageCssClass: string;
  printableImageClass: string;
  breadcrumbCssClass: string;
  breadcrumbTitleCssClass: string;
  tablesCssClass: string;
  fullLeftPanelCssClass: string;
  leftPanelCssClass: string;
  estimateImageCssClass: string;
  printAvailable: boolean;
}
